module.exports = __webpack_public_path__ + "app/kiss-order/detail/order-detail-2EOBgv0o.html";